/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-handler-names */
import React from 'react';
import styles from './index.module.less';
import { ReoIcon } from '@reolink-web/components.basic';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
type TValueType = number | string;

interface IDrawerSelectOptionItem {
    value: TValueType;
    label: string;
}

interface IDrawerSelectProps {
    options: IDrawerSelectOptionItem[];
    className?: string;
    value?: TValueType;
    onChange?: (value: any) => void;
}

interface IDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    options: IDrawerSelectOptionItem[];
    value?: TValueType;
    onChange?: (value: any) => void;
}

const CompDrawer: React.FC<IDrawerProps> = (props) => {
    return ReactDOM.createPortal(
        <div
            className={ classNames(styles['option-drawer-container'], {
                [styles['option-drawer-show']]: props.isOpen,
            }) }
        >
            <div
                className={ styles['option-drawer-mask'] }
                onClick={ props.onClose }></div>
            <ul className={ styles['options-list'] }>
                {props.options.map((item) => {
                    return (
                        <li
                            key={ item.value }
                            className={ classNames(styles['option-item'], {
                                [styles['option-item-active']]: props.value === item.value,
                            }) }
                            onClick={ () => {
                                props.onChange?.(item.value);
                                props.onClose();
                            } }
                        >
                            <span className={ styles['option-item-text'] }>{item.label}</span>
                            {props.value === item.value ? (
                                <ReoIcon
                                    name={ 'icon-check' }
                                    className={ styles['option-item-icon'] } />
                            ) : null}
                        </li>
                    );
                })}
            </ul>
        </div>,
        document.body,
    );
};

const CompDrawerSelect: React.FC<IDrawerSelectProps> = (props) => {
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

    const valueMap = React.useMemo(() => {
        return props.options.reduce<Record<TValueType, string>>((acc, item) => {
            acc[item.value] = item.label;
            return acc;
        }, {});
    }, [props.options]);

    return (
        <div
            className={ classNames(styles['drawer-select-container'], props.className, {
                [styles['drawer-select-show-drawer']]: isDrawerOpen,
            }) }
        >
            <span
                className={ styles['drawer-select-input-wrapper'] }
                onClick={ () => {
                    setIsDrawerOpen(true);
                } }
            >
                <input
                    readOnly={ true }
                    // eslint-disable-next-line react/no-unknown-property
                    unselectable={ 'on' }
                    style={{ opacity: 0 }}
                    className={ styles['drawer-select-input'] }
                ></input>
                <span className={ styles['selected-label'] }>{valueMap[props.value ?? '']}</span>
                <ReoIcon
                    className={ styles['drawer-select-icon'] }
                    name={ 'icon-co_down' } />
            </span>
            <CompDrawer
                options={ props.options }
                isOpen={ isDrawerOpen }
                onClose={ () => {
                    setIsDrawerOpen(false);
                } }
                value={ props.value }
                onChange={ props.onChange }
            />
        </div>
    );
};
export default CompDrawerSelect;
